import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userTwoFaCredentialMenuRegistry = {
    core_userTwoFaCredential: {
        label: "User Two Fa Credential",
        link: PAGE_URL.USER_TWO_FA_CREDENTIAL_PAGE,
        key: PAGE_URL.USER_TWO_FA_CREDENTIAL_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userTwoFaCredentialMenuRegistry;
